module.exports = "<ng-content></ng-content>\nCounter Stepper: {{counter}}<br>\n"